import ButtonGroup from '@omilia/button';
import styled from 'styled-components';

export const SForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > div:nth-child(2) {
    align-self: flex-end;
  }
`;

export const SInputsContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const SButtonGroup = styled(ButtonGroup)`
  justify-content: flex-end;
`;

export const SFormGroupSelect = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;
  padding-top: 6px;

  & > div > div {
    min-width: 0;
  }
`;

export const SField = styled.div`
  display: flex;
  flex: 5;
`;

export const SGroupHeading = styled.hr`
  margin: 0;
`;
